import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSLodgifyStore = GenericCollectionFactory("PMS-LODGIFY-INTEGRATION", "id");